<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize text-danger">
        Request For Quotes | <b> ARCHIVED SKUs </b>
      </h2>
    </div>
    <div class="kt-portlet__head-toolbar"> </div>
  </div>

  <div class="kt-portlet__body">
    <ng-template #sort let-order="order" let-field="field">
      <div class="pull-right sort">
        <i
          class="fas fa-sort"
          *ngIf="!field || !order || order.indexOf(field) < 0"
        ></i>
        <i class="fas fa-sort-up" *ngIf="order == field"></i>
        <i class="fas fa-sort-down" *ngIf="order == '-' + field"></i>
      </div>
    </ng-template>

    <div class="kt-widget filter">
      <div class="form-group">
        <label for="">Created Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filter.date"
          (keyup.enter)="getRecords(false, 1)"
          (change)="getRecords(false, 1)"
        />
      </div>

      <div class="form-group">
        <label for="">Product SKU</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.sku"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>

      <div class="form-group">
        <label for="">Product Name</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.product"
          (keyup.enter)="getRecords(false, 1)"
        />
      </div>

      <div class="form-group">
        <label for="">Product Dept</label>
        <select
          class="form-control"
          [(ngModel)]="filter.rfq_dept"
          (change)="getRecords(false, 1)"
        >
          <option value="0">All</option>
          <option *ngFor="let pt of settingsSvc.productDepartments" [value]="pt.id">
            {{ pt.text }}</option
          >
        </select>
      </div>

      <div class="form-group mw-200">
        <br />
        <button class="btn btn-outline-info btn-sm mr-1" (click)="resetFields()">
          <i class="fas fa-eraser"></i> Reset Filters
        </button>
      </div>
    </div>

    <button
      class="btn btn-warning btn-sm mr-2"
      *ngIf="checkedCount > 0"
      (click)="deleteSelected()"
    >
      <i class="fas fa-trash"></i> Delete Selected SKUs
    </button>

    <div class="overflow-auto">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th
              *ngIf="
                authService.loginUser.role > 2 && authService.loginUser.prwx == 7
              "
            >
              <mat-checkbox
                color="primary"
                [(ngModel)]="checkedAll"
                (ngModelChange)="checkAll()"
              >
              </mat-checkbox>
            </th>
            <th
              class="link"
              (click)="setOrder('created_at')"
              [translate]="'TITLES.DATE_TIME_CREATED'"
            >
              Created Date/Time
              <ng-container
                *ngTemplateOutlet="
                  sort;
                  context: {
                    order: filter.order,
                    field: 'created_at',
                  }
                "
              >
              </ng-container>
            </th>
            <th
              class="link"
              (click)="setOrder('product_name')"
              [translate]="'TITLES.PRODUCT'"
            >
              Product Name
              <ng-container
                *ngTemplateOutlet="
                  sort;
                  context: {
                    order: filter.order,
                    field: 'product_name',
                  }
                "
              >
              </ng-container>
            </th>
            <th class="link text-right"> Incoming </th>
            <th class="link text-right"> On Hand </th>
            <th class="link text-right"> Pending </th>
            <th class="link text-right"> Available </th>
            <th class="text-right"> Unit Cost </th>
            <th class="text-center">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="gettingRecords">
            <td colspan="10" class="text-center">
              <br />
              <h6 [translate]="'GENERAL.GETTING_RECORDS'">
                <i class="fas fa-spinner fa-spin"></i> Getting records...
              </h6>
              <br />
            </td>
          </tr>
          <tr *ngIf="!gettingRecords && rfqRecord.data.length == 0">
            <td colspan="10" class="text-center">
              <br />
              <h6 class="text-warning">No record found.</h6>
              <br />
            </td>
          </tr>
          <tr
            *ngFor="let r of rfqRecord.data; let i = index"
            [ngClass]="{
              checked: checked[r.id],
              'low-quantity':
                r.qty_limit_notify > 0 && r.qty_available <= r.qty_limit_notify,
            }"
          >
            <td
              *ngIf="
                authService.loginUser.role > 2 && authService.loginUser.prwx == 7
              "
            >
              <mat-checkbox
                color="primary"
                [(ngModel)]="checked[r.id]"
                (ngModelChange)="countChecked()"
              >
              </mat-checkbox>
            </td>
            <td> {{ r.created_at | date: 'medium' }} <br /> </td>
            <td class="text-capitalize">
              <a
                href="javascript:;"
                class="star mr-1"
                (click)="rfqService.toggleStarred(r)"
                ngbPopover="{{ r.starred ? r.starred_notes : '' }}"
                placement="top"
                triggers="mouseenter:mouseleave"
                title="{{ r.starred ? '' : 'Mark this SKU as starred' }}"
              >
                <i class="fas fa-star text-success" *ngIf="r.starred == 1"></i>
                <i class="far fa-star text-secondary" *ngIf="r.starred == 0"></i>
              </a>

              <a
                href="javascript:;"
                title="View Details"
                [ngClass]="{ 'text-linethrough': r.is_discontinued == 1 }"
                class="link mr-1"
                (click)="showDetails(r)"
              >
                <span
                  class="sku"
                  *ngIf="r.internal_sku && r.internal_sku.length > 3"
                >
                  [{{ r.internal_sku }}]
                </span>
                {{ r.product_name }}
              </a>
              <div class="statuses">
                <span
                  *ngIf="r.status == 1 || r.posted_quotes_count == 0"
                  class="kt-badge kt-badge--info kt-badge-sm kt-badge--inline kt-badge--pill"
                  [translate]="'QUOTE_STATUS.OUT_FOR_QUOTE'"
                  >Out for Quote</span
                >

                <span
                  *ngIf="r.price_negotiation_count > 0"
                  class="
                    kt-badge kt-badge--warning kt-badge-sm kt-badge--outline kt-badge--pill
                  "
                >
                  {{ r.price_negotiation_count }} Price Requests</span
                >

                <span
                  *ngIf="r.requote_requests_count > 0"
                  class="
                    kt-badge kt-badge--danger kt-badge-sm kt-badge--outline kt-badge--pill
                  "
                >
                  {{ r.requote_requests_count }} Re-Quote Requests</span
                >

                <span
                  *ngIf="r.posted_quotes_count > 0"
                  class="
                    kt-badge kt-badge--success kt-badge-sm kt-badge--outline kt-badge--pill
                  "
                >
                  {{ r.posted_quotes_count }} Quotations</span
                >

                <span
                  *ngIf="r.bulk_orders_count > 0"
                  class="kt-badge kt-badge--success kt-badge-sm kt-badge--pill"
                >
                  {{ r.bulk_orders_count }} Bulk orders</span
                >

                <span
                  *ngIf="r.sample_orders_count > 0"
                  class="kt-badge kt-badge--info kt-badge-sm kt-badge--pill"
                >
                  {{ r.sample_orders_count }} Sample orders</span
                >
              </div>
            </td>

            <td class="text-right">
              <a
                href="javascript:;"
                (click)="gotoPurchaseOrders(r)"
                title="View SKU purchase orders"
              >
                {{ (r.stock ? r.stock.qty_incoming : 0) | decimalPlaces }}
              </a>
            </td>
            <td class="text-right">
              {{ (r.stock ? r.stock.qty_onhand : 0) | decimalPlaces }}
            </td>
            <td class="text-right">
              {{ (r.stock ? r.stock.qty_pending : 0) | decimalPlaces }}
            </td>
            <td class="text-right">
              <span
                [ngClass]="{
                  'text-danger font-500':
                    r.qty_limit_notify > 0 &&
                    r.stock &&
                    r.stock.qty_onhand - r.stock.qty_pending <= r.qty_limit_notify,
                }"
              >
                {{
                  (r.stock ? r.stock.qty_onhand - r.stock.qty_pending : 0)
                    | decimalPlaces
                }}
              </span>
            </td>
            <td class="text-right">
              <ng-template #popContent>
                <div>
                  <label for="">Weighted: </label>
                  <span
                    class="value"
                    *ngIf="r.unit_costs.weighted && r.unit_costs.weighted > 0"
                  >
                    {{ r.unit_costs.weighted | currency }}</span
                  >
                  <span
                    class="value"
                    *ngIf="
                      (!r.unit_costs.weighted || r.unit_costs.weighted == 0) &&
                      r.base_price &&
                      r.base_price.weighted > 0
                    "
                  >
                    {{ r.base_price.weighted | currency }}</span
                  >
                </div>
                <div>
                  <label for="">FIFO: </label>
                  <!-- <span class="value"> {{r.unit_costs.fifo | currency: ''}}</span> -->
                  <span
                    class="value"
                    *ngIf="r.unit_costs.fifo && r.unit_costs.fifo > 0"
                  >
                    {{ r.unit_costs.fifo | currency }}</span
                  >
                  <span
                    class="value"
                    *ngIf="
                      (!r.unit_costs.fifo || r.unit_costs.fifo == 0) &&
                      r.base_price &&
                      r.base_price.fifo > 0
                    "
                  >
                    {{ r.base_price.fifo | currency }}</span
                  >
                </div>
                <div>
                  <label for="">Latest PO: </label>
                  <!-- <span class="value"> {{r.unit_costs.lastPo | currency: ''}}</span> -->
                  <span
                    class="value"
                    *ngIf="r.unit_costs.lastPo && r.unit_costs.lastPo > 0"
                  >
                    {{ r.unit_costs.lastPo | currency }}</span
                  >
                  <span
                    class="value"
                    *ngIf="
                      (!r.unit_costs.lastPo || r.unit_costs.lastPo == 0) &&
                      r.base_price &&
                      r.base_price.lastpo > 0
                    "
                  >
                    {{ r.base_price.lastpo | currency }}</span
                  >
                </div>
              </ng-template>

              <span
                class="weighted"
                [ngbPopover]="popContent"
                popoverTitle="Unit Costs"
                placement="top"
                triggers="mouseenter:mouseleave"
              >
                <!-- {{r.unit_costs.weighted | currency: ''}} -->
                <span
                  class="value"
                  *ngIf="r.unit_costs.weighted && r.unit_costs.weighted > 0"
                >
                  {{ r.unit_costs.weighted | currency }}</span
                >
                <span
                  class="value"
                  *ngIf="
                    (!r.unit_costs.weighted || r.unit_costs.weighted == 0) &&
                    r.base_price &&
                    r.base_price.weighted > 0
                  "
                >
                  {{ r.base_price.weighted | currency }}</span
                >
              </span>
            </td>
            <td class="actions text-right">
              <div ngbDropdown class="d-inline-block" *ngIf="!checked[r.id]">
                <button
                  ngbDropdownToggle
                  mat-mini-fab
                  type="button"
                  color="default"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="flaticon-more-1"></i>
                </button>

                <div ngbDropdownMenu aria-labelledby="action-button">
                  <button
                    ngbDropdownItem
                    (click)="delete(r, i)"
                    class="text-danger"
                    *ngIf="
                      authService.loginUser.is_admin &&
                      authService.loginUser.prwx == 7
                    "
                  >
                    <i class="fas fa-trash text-danger"></i>
                    Delete SKU
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <mat-paginator
        [length]="rfqRecord.total"
        [pageSize]="rfqRecord.per_page"
        [pageSizeOptions]="pageSizeOptions"
        (page)="getRecords($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
